import { useState } from "react";

export const useLocalStorage = (keyName, defaultValue) => {
    const [storedValue, setStoredValue] = useState(() => {
        const value = window.localStorage.getItem(keyName);
        return value || defaultValue;
    });
    const setValue = (newValue) => {
        try {
            window.localStorage.setItem(keyName, newValue);
            // eslint-disable-next-line no-empty
        } catch (err) { }
        setStoredValue(newValue);
    };
    return [storedValue, setValue];
};